//import jQuery from 'jquery';
//const gsap = require('gsap');
//require('gsap/ScrollTrigger');
//import {gsap} from "../node_modules/gsap";

//gsap.registerPlugin(ScrollTrigger);
let scroll_bar_width = getScrollbarWidth();
let scroll_bar_half_width = scroll_bar_width/2;

jQuery('body').css('--scroll-bar-half-width', scroll_bar_half_width + 'px');
jQuery(document).ready(function() {
    changeLinkAxeptio();
    changeAccordionFooter();
    //changeStyleMiniCart();
    initLabelMiniCart();
    readMore();
    scrollTop();
    initWoocommerceListView();
    addArrowFilterTitle();
    initPopupFilterBy();
    initNRBlockAccordion();
    initYithFilterCheckbox();
    addBtnPlusMinusQuantity();
    triggerClick();
    modifyCriteriaOfNrSimulator();

    if(jQuery('.nr-block-mega-menu').length > 0){
        loadBlockMegaMenu();
    }

    if(jQuery('.nr-product-add-to-cart a').length > 0){
        jQuery('.nr-product-add-to-cart a').click(function(){
            jQuery('form.cart button[type="submit"]').trigger('click');
        });
    }

    // Block Internal Linking - Ouvrir / Fermer les accordéons
    if(jQuery('.wp-block-nr-gutenberg-blocks-internal-linking').length > 0){
        jQuery('.wp-block-nr-gutenberg-blocks-internal-linking .nr-block-internal-linking-heading').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }

    // Block Internal Linking Category Product - Ouvrir / Fermer les accordéons
    if(jQuery('.nr-block-internal-linking-category-products').length > 0){
        jQuery('.nr-block-internal-linking-category-products .nr-block-internal-linking-title').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }

    // Block Selection Products By Category
    if(jQuery('.wp-block-nr-gutenberg-blocks-selection-products-by-category').length > 0){
        jQuery('.wp-block-nr-gutenberg-blocks-selection-products-by-category .nr-arrow').click(function(){
            scrollingLeft(jQuery(this));
        });
    }

    if(jQuery('#nr-topbar').length > 0){
        // Disparition de la topbar
        hideHeaderTopBar();
    }

    jQuery('.has-background').each(function() {
        let $current = jQuery(this);
        let $prev = $current.prev('.has-background');

        // Vérifier si l'élément précédent existe et a une classe
        if ($prev.length && $prev.attr('class')) {
            let currentClasses = $current.attr('class').split(' ');
            let prevClasses = $prev.attr('class').split(' ');

            let currentBackgroundClass = currentClasses.find(c => c.includes('has-') && c.includes('-background-color'));
            let prevBackgroundClass = prevClasses.find(c => c.includes('has-') && c.includes('-background-color'));

            // Appliquer le style si les deux éléments ont une classe de fond correspondante
            if (currentBackgroundClass && prevBackgroundClass && currentBackgroundClass === prevBackgroundClass) {
                $current.css('padding-top', '0');
            }
        }
    });

    /* Au scroll, montrer ou cacher header topbar */
    jQuery(window).scroll(function(){
        if(jQuery(document).scrollTop() > 200){
            jQuery('#nr-topbar').hide();
        }
        else if(jQuery(document).scrollTop() == 0){
            if(jQuery('#nr-topbar').is(":hidden")){
                jQuery('#nr-topbar').show();
            }
        }
    });
});

// HEADER - Simuler le clic sur le bouton "Panier" quand on clique sur le label
jQuery("#nr-logo-search .nr-cart > p").click(function(){
    jQuery("#nr-logo-search button").trigger("click");
})

jQuery(document).on('change', '.nr-variation-radios input', function(){
    changeDropdownProductVariations();
});

// FOOTER - Ouvrir / Fermer les accordéons du footer
function changeAccordionFooter(){
    var details = jQuery('details');
    // Si desktop, ouvrir les accordéons
    if(window.innerWidth >= 1024){
        details.each(function(){
            if(!jQuery(this).attr('open')){
                jQuery(this).attr('open', true);
            }
        });
    }
    // Si mobile, fermer les accordéons sauf le premier
    else {
        details.each(function(index){
            if(index != 0 && jQuery(this).attr('open')){
                jQuery(this).removeAttr('open');
            }
        })
    }
}

/* Cache la topbar du header */
function hideHeaderTopBar(){
    jQuery('#nr-topbar .nr-img-cross img').click( function(){
        jQuery('#nr-topbar').remove();
    });
}

// Actions et événements liés au bloc mega menu
function loadBlockMegaMenu(){
    // Clic sur le menu burger
    jQuery('.nr-block-mega-menu .nr-icons-menu').click(function(){
        //.nr-block-mega-menu
        jQuery(this).parent().toggleClass('open');
        jQuery('#nr-logo-search').parent().toggleClass('pgut-header__content__dark-background');

        // Si le menu des catégories parentes et enfants ne contiennent pas la classe open
        // Alors on ajoute la classe open au menu des catégories parentes
        if(!jQuery(this).parents('.nr-block-mega-menu').find('.nr-menu-children-product-categories').hasClass('open') && !jQuery(this).parents('.nr-block-mega-menu').find('.nr-menu-parent-product-categories').hasClass('open')){
            jQuery(this).parents('.nr-block-mega-menu').find('.nr-menu-parent-product-categories').toggleClass('open');
        }

    });

    // Clic sur le bouton "Fermer"
    jQuery('.nr-block-mega-menu .nr-top-menu img:nth-of-type(2)').click(function(){
        jQuery(this).parents('.nr-block-mega-menu').removeClass('open');
        jQuery('#nr-logo-search').parent().removeClass('pgut-header__content__dark-background');
    });

    // Clic sur le bouton "Suite" d'une catégorie pour voir les sous-catégories
    jQuery('.nr-block-mega-menu .nr-parent-product-category.nr-parent-has-child').click(function(){
        var id_parent_category = jQuery(this).attr('data-id');
        var block_mega_menu = jQuery(this).parents('.nr-block-mega-menu');

        // Sur le bouton "Retour en arrière", on ajoute l'id de la catégorie parente
        // + on l'affiche
        block_mega_menu.find('.nr-top-menu').attr('data-id', id_parent_category).addClass('show');

        // Cacher le menu des catégories parentes
        block_mega_menu.find('.nr-menu-parent-product-categories').removeClass('open');

        // Afficher le menu des catégories enfants
        block_mega_menu.find('.nr-menu-children-product-categories').addClass('open');

        // Cacher toutes les catégories enfant ouvertes
        block_mega_menu.find('.nr-menu-child-product-categories.open').removeClass('open');

        // Afficher le bon sous-menu des catégories enfant en fonction de la catégorie parent choisie
        block_mega_menu.find('.nr-menu-child-product-categories[data-id="'+id_parent_category+'"]').addClass('open');
    });

    // Clic sur le bouton "Retour en arrière"
    jQuery('.nr-block-mega-menu .nr-top-menu img:first-child').click(function(){
        // Si le bouton a bien l'attribut data-id
        if(jQuery(this).parent().attr('data-id') != null){
            var id_back = jQuery(this).parent().attr('data-id');
            var menu_content = jQuery(this).parents('.nr-menu-content');

            // Afficher le menu des catégories parentes
            menu_content.find('.nr-menu-parent-product-categories').toggleClass('open');

            menu_content.find('.nr-parent-product-category[data-id="'+id_back+'"]').toggleClass('open');

            // Si le menu des catégories enfant est ouvert
            // Alors on le cache
            if(menu_content.find('.nr-menu-children-product-categories').hasClass('open')){
                menu_content.find('.nr-menu-children-product-categories').removeClass('open');
            }

            if(menu_content.find('.nr-menu-child-product-categories').hasClass('open')){
                menu_content.find('.nr-menu-child-product-categories').removeClass('open');
            }

            // Cacher l'icône "Retour en arrière"
            jQuery(this).parent().removeAttr('data-id').removeClass('show');
        }
    });
}

/*
 * Implémentation du bouton "readmore"
 */
function readMore(action = 'hide') {
    let elements =  jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this).parent();
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this).parent(), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}

/*function changeStyleMiniCart() {
    jQuery('div[data-block-name="woocommerce/mini-cart"] .wc-block-mini-cart__quantity-badge svg').eq(0).replaceWith('<img src="/wp-content/themes/nr_gutenberg/assets/svg/icons/nr-mini-cart.svg" /><span class="nr-label-button-cart">Mon panier</span>');

    jQuery('div[data-block-name="woocommerce/mini-cart"] button').unbind('mouseover');
    jQuery('div[data-block-name="woocommerce/mini-cart"] button').unbind('focus');

    jQuery('div[data-block-name="woocommerce/mini-cart"] button').on('mouseout',function(){
        setTimeout(changeStyleMiniCart(), 1500);
    });
}*/

function initLabelMiniCart(){
    jQuery('.nr-block-wc-account-cart .nr-label-button-cart').click(function(){
        jQuery('.wc-block-mini-cart__button').trigger('click');
    });
}

function getScrollbarWidth() {

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

// Scroll to left or right inside an element
function scrollingLeft(element_arrow) {
    var width_scroll = element_arrow.closest('.nr-list-miniature-product').find('.nr-miniature-product').width()+18;
    var scroll_left = 0;
    if(element_arrow.hasClass('nr-arrow-left')){
        scroll_left = "-="+width_scroll+"px";
    }
    else {
        scroll_left = "+="+width_scroll+"px";
    }
    element_arrow.closest('.nr-list-miniature-product').animate({
        scrollLeft: scroll_left
    }, "slow");
}

// Scroll to top of the page
function scrollTop(){
    jQuery('.nr-scroll-top').click(function(){
        jQuery('html, body').animate({scrollTop: '0px'}, 500);
    });
}

function initWoocommerceListView(){
    if(jQuery('.nr-woocommerce-listing').length > 0){
        var cookieNRWoocommerceListingValue = document.cookie.replace(/(?:(?:^|.*;\s*)nr_woocommerce_listing\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(cookieNRWoocommerceListingValue){
            changeWoocommerceListView()
        }

        jQuery('.nr-woocommerce-listing').on('click', function(){
            jQuery('.nr-woocommerce-listing').removeClass('active');
            jQuery(this).addClass('active');
            var style_list = jQuery(this).attr('data-style');
            document.cookie = 'nr_woocommerce_listing='+style_list+';';
            changeWoocommerceListView();
        });
    }
}

function changeWoocommerceListView(){
    if(jQuery('.nr-woocommerce-listing').length > 0){
        var cookieNRWoocommerceListingValue = document.cookie.replace(/(?:(?:^|.*;\s*)nr_woocommerce_listing\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(cookieNRWoocommerceListingValue){
            jQuery('.products .product').each(function(){
                jQuery(this).removeClass('grid list').addClass(cookieNRWoocommerceListingValue);
            });

            jQuery('.nr-woocommerce-style-listing .nr-woocommerce-listing').each(function(){
                jQuery(this).removeClass('active');
                jQuery('.nr-shop-results').removeClass('grid list').addClass(cookieNRWoocommerceListingValue);

                if(jQuery(this).hasClass('nr-woocommerce-listing-'+cookieNRWoocommerceListingValue)){
                    jQuery(this).addClass('active');
                }
            });
        }
    }
}

function changeDropdownProductVariations(){
    jQuery( '.nr-variation-radios input:checked' ).each( function( index, element ) {
        const radio = jQuery(element);
        const radioName = radio.attr( 'name' )
        const radioValue  = radio.attr( 'value' )
        jQuery( 'select[name="' + radioName + '"]' ).val( radioValue ).trigger( 'change' );
    })
}

function addArrowFilterTitle(){
    if(jQuery('.archive.tax-product_cat .nr-shop-sidebar .wc-blocks-filter-wrapper .wp-block-heading').length > 0){
        jQuery('.archive.tax-product_cat .nr-shop-sidebar .wc-blocks-filter-wrapper .wp-block-heading').each(function(index,element){
            jQuery('<img src="/wp-content/themes/nr_gutenberg/build/svg/icons/arrow-accordion-top.svg" alt="" />').appendTo(element);

            jQuery('.nr-sidebar-shop > div:first-child .wc-blocks-filter-wrapper').addClass('active');
            jQuery('.nr-sidebar-shop-technical-features > div:first-child .wc-blocks-filter-wrapper').addClass('active');

            jQuery(this).click( function(){
                jQuery(this).parent().toggleClass('active');
            })
        });
    }
}

function initPopupFilterBy(){
    if(jQuery('body .nr-shop-sidebar').length > 0){
        jQuery('.nr-shop-sidebar .nr-open-popup').click(function(){
            jQuery('.nr-shop-sidebar .nr-sidebars').addClass('open');
        });

        jQuery('.nr-shop-sidebar .nr-close-popup').click(function(){
            jQuery('.nr-shop-sidebar .nr-sidebars').removeClass('open');
        });
    }
}

function initNRBlockAccordion()
{
    if(jQuery('body .wp-block-nr-gutenberg-blocks-accordion').length > 0){
        jQuery('.wp-block-nr-gutenberg-blocks-accordion .nr-heading').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }
}

function initYithFilterCheckbox(){
    if(jQuery('.yith-wcan-filters').length > 0){
        jQuery('.yith-wcan-filters').click(function(e){
            if(e.target.className == "filter-title"){
                e.target.parentElement.classList.toggle('open');
            }
        });
    }
}

/* Increase or decrease input number quantity thanks to span minus and plus */
function addBtnPlusMinusQuantity(){
    if(jQuery('.woocommerce input.qty:not([type=hidden])').length > 0){
        jQuery('.woocommerce input.qty:not([type=hidden])').each(function(){
            jQuery(this).before('<span class="nr-btn-minus"><img src="/wp-content/themes/nr_gutenberg/assets/svg/icons/icon-minus.svg" alt="Icône moins" /></span>');
            jQuery(this).after('<span class="nr-btn-plus"><img src="/wp-content/themes/nr_gutenberg/assets/svg/icons/icon-plus.svg" alt="Icône plus" /></span>');

            jQuery('.nr-btn-minus').click(function(){
                jQuery(this).next('.qty').val(Math.max(parseInt(jQuery(this).next('.qty').val())-1, 0));
            });

            jQuery('.nr-btn-plus').click(function(){
                jQuery(this).prev('.qty').val(parseInt(jQuery(this).prev('.qty').val())+1);
            });
        });
    }
}

function changeLinkAxeptio(){
    if(jQuery('a[href="#manage-axeptio"]').length > 0){
        jQuery('a[href="#manage-axeptio"]').attr('href', 'javascript:openAxeptioCookies()');
    }
}

// Rendre un élément cliquable alors qu'il ne possède un lien que sur une petite zone
function triggerClick() {
    if(jQuery('.nr-click').length > 0){
        // mouseup plutôt que click pour le lic roulette
        jQuery('.nr-click').mouseup(function(e){
            if(e.which == 1){
                // Pour ouvrir dans un nouvel onglet
                if(jQuery(this).find('.nr-click-link').eq(0).attr("target") == "_blank" ){
                    window.open(jQuery(this).find('.nr-click-link').eq(0).attr("href"));
                }
                else {
                    window.location.href = jQuery(this).find('.nr-click-link').eq(0).attr("href");
                }
            }
            else if(e.which == 2){
                window.open(jQuery(this).find('.nr-click-link').eq(0).attr("href"));
            }
        });
    }
}

// NR Simulator
// Si on clique sur le btn 'Modifier mes critères'
// on fait un clic sur la page précédente pour garder les données du formulaire
function modifyCriteriaOfNrSimulator(){
    jQuery('#trouver-votre-produit').click(function(e){
        if(e.target.id === "nr_simulator_modify_criteria"){
            window.history.go(-1);
        }
    });
}